import { AnimatePresence, motion } from 'framer-motion';
import React, { Suspense, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Notifications from '../../components/notifications/Notifications.component';
import { selectUser } from '../../redux/globals/globals.selectors';

import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react/swiper-react';

import './Game.styles.scss';
import Button from '../../components/buttons/button.component';
import { getLogedUser, setUser, updateSelectedDriver } from '../../redux/globals/globals.actions';
import SvgIcon from '../../components/svg-icon/svg-icon.component';
import Popup from '../../components/popup/Popup';
import Help from '../Help.component';
import { TabberContext } from '../../components/tabber/Tabber.provider';
import Preloader from '../../components/preloader/Preloader.component';
import { Canvas } from '@react-three/fiber';

import { useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { ContactShadows, Float, OrbitControls, Shadow } from '@react-three/drei';

const GameScreen = ({ data, startGame }) => {
	const user = useSelector(selectUser);
	const dispatch = useDispatch();
	//const swiper = useRef();
	//const [selected, setSelected] = useState();
	const [helpOpen, setHelpOpen] = useState();
	const { tabberData, setTabberData } = useContext(TabberContext);
	const [assetsLoaded, setAssetsLoaded] = useState(false);
	const [driverMedatada, setDriverMetadata] = useState();

	const gltf = useLoader(GLTFLoader, '/assets/hero_ship_1.gltf');

	useEffect(() => {
		console.log('init');
	}, []);

	console.log(driverMedatada);

	useEffect(() => {
		if (!user) return;

		if (user?.driver_metadata) setDriverMetadata(JSON.parse(user?.driver_metadata));
	}, [user]);

	/* useEffect(() => {
		if (!user) return;
		//setDriverMetadata(JSON.parse(user.driver_metadata));
		console.log('USER');

		//get selected
		for (let i = 0; i < user.tokens.ownedNfts.length; i++) {
			if (
				`${user.tokens.ownedNfts[i].contract.address.toLowerCase()}/${user.tokens.ownedNfts[i].id.tokenId}` ===
				`${user.driver_contract.toLowerCase()}/${user.driver_token_id}`
			) {
				console.log('selected', i);
				setSelected(i);

				if (typeof swiper.current !== 'undefined' && swiper.current.realIndex !== i) {
					//not likes
					swiper.current.slideTo(i);
					//setSelected(i);
					break;
				}
			}
		}
	}, [user]); */

	/* const updateDriver = async (selectedIndex) => {
		if (selected === selectedIndex) return;

		await dispatch(updateSelectedDriver(user.tokens.ownedNfts[selectedIndex]));
		let res = await dispatch(getLogedUser());
		await dispatch(setUser(res.data));
	}; */

	return (
		<>
			<div className="gameScreen">
				<div className="right">
					<div className="alphaRelease">
						<div className="title">Alpha release</div>
						<div className="desc">
							Pocket Rockets is in Alpha <span>"fun only"</span> release.
							Play on mobile, tablet, or desktop. Join the community to develop together.
						</div>
						<a target="_blank" href="https://discord.gg/pocketrockets">
							<div className="icon discord">
								<img src="/assets/images/logos/discord.svg" />
							</div>
						</a>
					</div>
					<Notifications />
				</div>

				<div className="left">
					<div className="playbutton">
						<Button
							className="cta-glow configure"
							onClick={() => {
								setHelpOpen(true);
							}}
						>
							HELP
						</Button>

						<Button className="cta-glow play" onClick={startGame}>
							START GAME
						</Button>
					</div>
				</div>

				<div className="middle">
					<motion.div className="shipContainer" initial={{ y: -20 }} animate={{ y: 0 }} transition={{ duration: 1 }}>
						<div className="driverContainer">
							<div className="upper">
								<div className="title">
									<span>Select</span>Your driver
								</div>
								<div
									className="viewAll"
									onClick={() => {
										setTabberData({ ...tabberData, selected: 2 });
									}}
								>
									Choose
								</div>
							</div>

							{user?.tokens?.ownedNfts?.length > 0 && user?.driver_image && (
								<div className="driverCards">
									<div className="driverCard">
										<img src={user?.driver_image?.replaceAll('256', '500')} />
										<div className="name">{driverMedatada?.title}</div>
										<div className="tokenid">#{parseInt(user.driver_token_id, 16)}</div>
									</div>
								</div>
							)}

							{(!user?.tokens?.ownedNfts || user.tokens.ownedNfts.length === 0) && (
								<div className="noDriver">
									<div className="title">Hey, you have no available drivers</div>
									<div className="desc">Maybe you should check out one of our supported drivers.</div>
									<Button
										onClick={() => {
											setTabberData({ ...tabberData, selected: 2 });
										}}
									>
										View drivers
									</Button>
								</div>
							)}

							{/* {user.tokens.ownedNfts.length > 0 && (
								<div className="driverCards">
									{selected >= 0 && (
										<Swiper
											//loop={true}
											spaceBetween={30}
											initialSlide={selected}
											onSwiper={(s) => (swiper.current = s)}
											modules={[Pagination, Navigation]}
											pagination={{ type: 'fraction', el: '.paging' }}
											navigation={{ enabled: true, prevEl: '.prev', nextEl: '.next' }}
											onSlideChange={(slider) => {
												console.log('on change', slider.realIndex);
												updateDriver(slider.realIndex);
											}}
										>
											{user &&
												user.tokens.ownedNfts.map((item, index) => (
													<SwiperSlide key={index}>
														<div className="driverCard">
															<img
																src={
																	item?.media?.[0]?.thumbnail
																		? item?.media?.[0]?.thumbnail.replaceAll('256', '500')
																		: item?.media?.[0]?.gateway
																}
															/>
															<div className="name">{item?.title}</div>
															<div className="tokenid">#{parseInt(item.id.tokenId, 16)}</div>
														</div>
													</SwiperSlide>
												))}
										</Swiper>
									)}
								</div>
							)} */}

							{/* {user.tokens.ownedNfts.length > 0 && (
								<>
									<div className={`next`}>
										<SvgIcon icon="icon-angle-left" />
									</div>
									<div className={`prev`}>
										<SvgIcon icon="icon-angle-right" />
									</div>

									<div className={`paging`}></div>
								</>
							)} */}
						</div>

						<div className="heroImage">
							<div className="rocketPlatformWrapper">
								<div className="heroBack">
									<img src="/assets/hero_back.png" />
								</div>
								<Canvas 
									camera={{ zoom: 1, position: [13, 2, 0], fov: 60 }} 
									className="THREElogo"
									gl={{ preserveDrawingBuffer: true }}
									onCreated={({ gl }) => {
										// Force canvas to respect container's actual (unscaled) size
										const container = gl.domElement.closest('.THREElogo');
										if (container) {
											// Get the container's computed max-width, not the scaled visual size
											const style = window.getComputedStyle(container);
											const maxWidth = parseInt(style.maxWidth) || container.getBoundingClientRect().width;
											const maxHeight = parseInt(style.maxHeight) || container.getBoundingClientRect().height;
											// Use the smaller of actual size or max constraint
											const width = Math.min(container.getBoundingClientRect().width, maxWidth);
											const height = Math.min(container.getBoundingClientRect().height, maxHeight);
											gl.setSize(width, height, false);
										}
									}}
								>
									<Suspense fallback={null}>
										<Float
											speed={1} // Animation speed, defaults to 1
											rotationIntensity={1} // XYZ rotation intensity, defaults to 1
											floatIntensity={2} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
											floatingRange={[-0.1, 0.3]} // Range of y-axis values the object will float within, defaults to [-0.1,0.1]
										>
											<group rotation={[0, 0.8, 0]} position={[0, -4.0, 0]}>
												<primitive object={gltf.scene} />
												<ContactShadows opacity={1} scale={25} blur={3} far={20} resolution={256} color="#000000" />
											</group>
										</Float>
										<ambientLight castShadow intensity={0.2} />

									<OrbitControls
										enableZoom={false}
										maxPolarAngle={1.8}
										minPolarAngle={1}
										minAzimuthAngle={0.3}
										maxAzimuthAngle={1.8}
										target={[0, -4.0, 0]}
									/>
									</Suspense>
								</Canvas>
							</div>

							<Preloader
								data={['/assets/platform.gltf']}
								onLoadComplete={() => {
									setAssetsLoaded(true);
								}}
							/>
						</div>
					</motion.div>
				</div>
			</div>

			<AnimatePresence>
				{helpOpen && (
					<Popup
						handleClose={() => {
							setHelpOpen(false);
						}}
					>
						<Help />
					</Popup>
				)}
			</AnimatePresence>
		</>
	);
};

export default GameScreen;
